import React from "react";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { FaRegQuestionCircle } from "react-icons/fa";
import { storeUrl } from "../constant";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { copyToClipboard } from '../utils/copyToClipboard';
import { saveToStorage, getAllKeys } from '../utils/storage';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { useFavorite, useDialog } from '../hooks';
import Translate from "../components/Translate";
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

const DealCard = (props) => {
  const [favorites, setFavorites] = useFavorite();
  const [dialog, setDialog] = useDialog();
  const [copyText, setCopyText] = React.useState('');
  const history = useHistory();

  const { deal, setStore, setGuide, setModalOpen, setGuideLoading } = props;
  const { dname, dcpn, dno, dimg, dstore, dmore, dprice, dsale, durl, productpage } = deal;
  const storageData = { dno, dname, dimg, durl };

  const goProductpage = Number(productpage) === 1;
  const href = goProductpage ? `/product?id=${dno}` : durl;

  const cardMargin = props.cardMargin ?? "10px";

  const regex = /^(.*?)\(原價/;
  const match = dname.match(regex);
  const finalname = match ? match[1] : dname;

  const copied = Translate("已複製");
  const buy = Translate("購買");
  const hasCoupon = dcpn !== "" && dcpn !== null;

  const routeChange = path => {
    history.push(path);
  };

  const handleClick = () => {
    if (goProductpage) {
      routeChange(href);
    } else {
      if(hasCoupon){
        goCoupon();
      }else{
        window.open(href, "_blank");
      }
    }
  };

  const goStore = () => {
    setDialog({ ...dialog, open: false });
    window.open(durl, "_blank");
  }

  const goMore = () => {
    setDialog({ ...dialog, open: false });
    routeChange(href);
  }

  const goCoupon = () => {
    if (dcpn === "" || dcpn === null) { handleClick(); return; }
    copyToClipboard(dcpn);
    // setDialog({
    //   open: true, content: <React.Fragment>
    //     <DialogTitle>Coupon: {dcpn} {copied}!</DialogTitle>
    //     <DialogContent>
    //       <DialogActions>
    //         {goProductpage && <Button onClick={goMore}>查看更多</Button>}
    //         <Button onClick={goStore} color='primary'>到 {dstore} {buy}</Button>
    //       </DialogActions>
    //     </DialogContent>
    //   </React.Fragment >
    // });
    setCopyText(copied);
    setTimeout(() => {
      setCopyText('');
    } , 3000);
  }

  const dealcpn = hasCoupon ? (
    <CardText style={{ position: "absolute", bottom: "65px" }}>
      Coupon:{" "}
      <span
        style={{
          display: "inline",
          fontSize: "1em",
          fontWeight: "bold",
          border: "1px dashed #1068af",
          backgroundColor: "#e2ecf5",
          color: "#00314c",
          padding: "0pt 5pt",
          margin: "1pt",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={goCoupon}
      >
        {dcpn}
      </span>
      {copyText}
    </CardText>
  ) : null;

  const getGuide = React.useCallback((store) => {
    setGuideLoading(true);
    const data = new FormData();
    if (!isNaN(store)) {
      data.append("sno", store);
    } else {
      data.append("store", store);
    }
    axios
      .post(storeUrl, data)
      .then((response) => {
        setGuide(response.data.guide);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setGuideLoading(false)
      );
  }, [setGuide, setGuideLoading]);

  const save = (data) => {
    saveToStorage(data);
    setFavorites(getAllKeys());
  };

  const favoriteIcon = favorites.includes(dno) ? (<Tooltip title={Translate("已收藏")} arrow placement="top-end"><FavoriteIcon color="secondary" /></Tooltip>) : (<Tooltip title={Translate("收藏")} arrow placement="top-end"><FavoriteBorderIcon className="cursor" color="primary" onClick={() => save(storageData)} /></Tooltip>);

  return (
    <Card
      style={{ width: "250px", height: "370px", margin: cardMargin }}
      key={dno}
    >
      <CardImg
        top
        width="100%"
        src={dimg}
        alt={dname}
        height="150px"
        style={{ objectFit: "contain" }}
        className="cursor"
        onClick={handleClick}
      />
      <CardBody>
        <CardSubtitle
          style={{
            color: "grey",
            fontSize: "14px",
          }}
        >
          {dstore}
          <Button
            style={{
              height: "20px",
              padding: "5px",
              fontSize: "12px",
              lineHeight: "0",
              right: "20px",
              position: "absolute",
              backgroundColor: "#e8e8e8",
              color: "black",
              display: dmore === "" ? "none" : "inline",
            }}
            onClick={() => {
              setStore(dstore);
              getGuide(dmore);
              setModalOpen(true);
            }}
          >
            {Translate('購買指南')} <FaRegQuestionCircle />
          </Button>
        </CardSubtitle>
        <CardTitle className="cursor cardTitle" onClick={handleClick}>
          {Translate(finalname)}
        </CardTitle>
        {dealcpn}
        <CardText
          style={{ position: "absolute", bottom: "40px", width: "210px" }}
        >
          <span style={{ color: "red", textDecoration: "line-through" }}>
            {dprice ? "$" : ""} {dprice}
          </span>
          <span style={{ color: "black", fontWeight: "bold" }}>
            &nbsp;{dsale ? "$" : ""}
            {dsale}
          </span>
          <span style={{ position: 'absolute', right: 0 }}>
            {favoriteIcon}
          </span>
        </CardText>
        <Button
          style={{
            width: "210px",
            bottom: "10px",
            position: "absolute",
            margin: "auto",
          }}
          onClick={handleClick} //hasCoupon ? goCoupon : 
        >
          {goProductpage ? Translate('由此查看') : Translate('由此購買')}
        </Button>
      </CardBody >
    </Card >
  );
};

export default DealCard;
